import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Card, Modal, ModalBody } from "reactstrap";
import {
  useCreateSystemAccount,
  useGetSystemAccount,
  useUpdateSystemAccount,
  useVerifyAccount,
} from "../../../../api/system-bank-account";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
} from "../../../../components/Component";
import Content from "../../../../layout/content/Content";
import Head from "../../../../layout/head/Head";
import LoadingSpinner from "../../../components/spinner";
import UserProfileAside from "./UserProfileAside";
const SystemAccountPage = () => {
  const [sm, updateSm] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  const [editedId, setEditId] = useState();
  const { isLoading, data } = useGetSystemAccount(1, 7);
  const { mutate: addAccount, isLoading: creating, isSuccess } = useCreateSystemAccount();
  const { mutate: editAccount, isLoading: editing, isSuccess: editSuccess } = useUpdateSystemAccount();
  // const { mutate: deleteAccount } = useDeletesystemAccount(editedId);
  // const { data: banks } = useGetBanks();
  // console.log(banks);

  //   console.log(data);

  // const bankOptions = useMemo(() => {
  //   if (banks) {
  //     return banks?.data?.map((item) => ({ code: item.id, label: item.name, value: item.name }));
  //   } else return [];
  // }, [banks]);
  // console.log(bankOptions)

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm();

  const [formData, setFormData] = useState({
    bankName: "",
    // bank_code: "",
    accountName: "",
    accountNumber: "",
    // type: "",
    // status: "",
    // created_at: "",
  });

  const { isLoading: verifying } = useVerifyAccount(formData, setFormData);

  const onEditClick = (id) => {
    data?.forEach((item) => {
      if (item.id === id) {
        setFormData({
          bankName: item.bankName,
          // bank_code: item.bank_code,
          accountName: item.accountName,
          accountNumber: item.accountNumber,
          // type: item.type,
          // status: item.status,
          // created_at: item.created_at,
        });
      }
    });
    setEditId(id);
    setIsEditing(true);
  };

  // resets forms
  const resetForm = () => {
    setFormData({
      bankName: "",
      // bank_code: "",
      accountName: "",
      accountNumber: "",
      // type: "",
      // status: "",
      // created_at: "",
    });
    setModal(false);
    setIsEditing(false);
  };

  useEffect(() => {
    if (editSuccess || isSuccess) {
      resetForm();
    }
  }, [isSuccess, editSuccess]);

  // console.log(data);

  // const [modalTab, setModalTab] = useState("1");
  const [modal, setModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  // const [forceUpdate, setForceUpdate] = useState(false);

  const onFormSubmit = (form) => {
    // console.log(form);
    let submittedData = {
      // bank_id: form.bank_code,
      accountName: form.accountName,
      accountNumber: form.accountNumber,
      bankName: form.bankName,
    };
    // console.log(submittedData);
    if (isEditing) {
      editAccount({ ...submittedData, bankId: editedId });
    } else {
      addAccount(submittedData);
    }
    // if (formData.accountName) {
    //   addAccount(submittedData);
    // } else {
    //   verify({
    //     bank_id: form.bank_code,
    //     account_number: form.account_number,
    //   });
    // }
  };

  // const closeModal = () => {
  //   setModal(false);
  //   reset({ title: "", value: "" });
  // };

  // function to change the design view under 990 px
  const viewChange = () => {
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      updateSm(false);
    }
  };

  // console.log(android?.is_required);

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    document.getElementsByClassName("nk-header")[0].addEventListener("click", function () {
      updateSm(false);
    });
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, []);

  useEffect(() => {
    if (formData) {
      reset(formData);
    }
  }, [formData, reset]);

  return (
    <React.Fragment>
      <Head title="Settings"></Head>
      <Content>
        <Card>
          <div className="card-aside-wrap">
            <div
              className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
                sm ? "content-active" : ""
              }`}
            >
              <UserProfileAside updateSm={updateSm} sm={sm} />
            </div>
            <div className="card-inner card-inner-lg">
              {sm && mobileView && <div className="toggle-overlay" onClick={() => updateSm(!sm)}></div>}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">System Bank Account</BlockTitle>
                    <BlockDes>
                      <p>Account Details associated with Fabstouch.</p>
                    </BlockDes>
                  </BlockHeadContent>
                  <BlockHeadContent className="align-self-start d-lg-none">
                    <Button
                      className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""}`}
                      onClick={() => updateSm(!sm)}
                    >
                      <Icon name="menu-alt-r"></Icon>
                    </Button>
                  </BlockHeadContent>
                </BlockBetween>
                <BlockBetween>
                  <p></p>
                  <Button size={"sm"} color="primary" onClick={() => setModal(true)} disabled={creating || verifying}>
                    Add
                  </Button>
                </BlockBetween>
              </BlockHead>

              <Block>
                <div className="nk-data data-list">
                  {isLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <>
                      {data?.map((item, index) => (
                        <div key={item.id}>
                          <div className="data-head">
                            <BlockBetween>
                              <h6 className="overline-title mb-0">Account Details {index + 1}</h6>
                              {/* {data?.length > 0 ? (
                            <div>
                              <a
                                href="#edit"
                                onClick={() => {
                                  setEditId(data?.data[0].id);
                                  deleteAccount();
                                }}
                                className="text-primary"
                              >
                                Delete
                              </a>
                            </div>
                          ) : ( */}
                              <div
                                onClick={() => {
                                  onEditClick(item.id);
                                  setModal(true);
                                }}
                              >
                                <a href="#edit" onClick={(e) => e.preventDefault()} className="text-primary">
                                  Edit
                                </a>
                              </div>
                              {/* )} */}
                            </BlockBetween>
                          </div>
                          <div>
                            <div
                              className="data-item"
                              onClick={() => {
                                setEditId(item?.id);
                              }}
                            >
                              <div className="data-col">
                                <span className="data-label">Bank Name</span>
                                <span className="data-value">{item?.bankName}</span>
                              </div>
                            </div>
                            {/* <div className="data-item">
                                <div className="data-col">
                                  <span className="data-label">Bank Code</span>
                                  <span className="data-value">{item?.bank_code}</span>
                                </div>
                              </div>{" "} */}
                            <div className="data-item">
                              <div className="data-col">
                                <span className="data-label">Account Number</span>
                                <span className="data-value">{item?.accountNumber}</span>
                              </div>
                            </div>
                            <div className="data-item">
                              <div className="data-col">
                                <span className="data-label">Account Name</span>
                                <span className="data-value">{item?.accountName}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </Block>

              <Modal isOpen={modal} className="modal-dialog-centered" size="lg" toggle={() => setModal(false)}>
                <a
                  href="#dropdownitem"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setModal(false);
                  }}
                  className="close"
                >
                  <Icon name="cross-sm"></Icon>
                </a>
                <ModalBody>
                  <div className="p-2">
                    <h5 className="title">{isEditing ? "Edit" : "Add"} Bank </h5>
                    <form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row className="g-3">
                        <Col md="12">
                          <div className="form-group">
                            <label className="form-label" htmlFor="bank_code">
                              Banks
                            </label>
                            <div className="form-control-wrap">
                              {/* <RSelect
                                options={bankOptions}
                                onChange={(e) => setFormData({ ...formData, bank_code: e.code })}
                              /> */}
                              <input
                                type="text"
                                className="form-control"
                                {...register("bankName", {
                                  required: "This field is required",
                                })}
                                onChange={(e) => setFormData({ ...formData, bankName: e.target.value })}
                                value={formData.bankName}
                              />

                              {errors.bankName && <span className="invalid">{errors.bankName.message}</span>}
                            </div>
                          </div>
                        </Col>

                        <Col md="12">
                          <div className="form-group">
                            <label className="form-label" htmlFor="account_number">
                              Account Number
                            </label>
                            <div className="form-control-wrap">
                              <input
                                type="number"
                                className="form-control"
                                {...register("accountNumber", {
                                  required: "This field is required",
                                })}
                                onChange={(e) => setFormData({ ...formData, accountNumber: e.target.value })}
                                value={formData.accountNumber}
                              />
                              {errors.accountNumber && <span className="invalid">{errors.accountNumber.message}</span>}
                            </div>
                          </div>
                        </Col>

                        <Col md="12">
                          <div className="form-group">
                            <label className="form-label" htmlFor="account_name">
                              Account Name
                            </label>
                            <div className="form-control-wrap">
                              <input
                                type="text"
                                className="form-control"
                                {...register("accountName")}
                                onChange={(e) => setFormData({ ...formData, accountName: e.target.value })}
                                value={formData.accountName}
                                // disabled
                              />
                              {errors.accountName && <span className="invalid">{errors.accountName.message}</span>}
                            </div>
                          </div>
                        </Col>

                        <Col size="12">
                          <Button color="primary" type="submit" disabled={creating || editing}>
                            <Icon className="plus"></Icon>
                            <span>{isEditing ? "Edit" : "Add"} Account</span>
                            {/* <span>{formData.accountName ? "Add" : "Verify"} Account</span> */}
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  </div>
                </ModalBody>
              </Modal>
            </div>
          </div>
        </Card>
      </Content>
    </React.Fragment>
  );
};

export default SystemAccountPage;
